var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShoppingCart({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M6 19.125h9.921a1.5 1.5 0 0 0 1.479-1.249l2.637-15.5a1.5 1.5 0 0 1 1.479-1.248h.984M7.875 21.375a.375.375 0 1 1-.375.375.375.375 0 0 1 .375-.375M15.375 21.375a.375.375 0 1 1-.375.375.375.375 0 0 1 .375-.375"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M17.953 14.625H5.882a3 3 0 0 1-2.91-2.272l-1.45-5.8a.75.75 0 0 1 .728-.932h17.234M6 8.625v2.25M10.5 8.625v2.25M15 8.625v2.25"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCart);
export default __webpack_public_path__ + "static/media/shopping-cart.eb7a1f156ac3b1064936b2da19c20064.svg";
export { ForwardRef as ReactComponent };